import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Grid,
  Checkbox,
  ListItemText,
  Autocomplete,
  Popper,
  Stack,
  Box,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  onGetHRMonthly_Review_Atrributes,
  onGetHRMonthly_Review_Summary,
} from "./HRAction";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { CmpDatePicker } from "../../Component/Common/ToolBox/ToolBox";

const gridColumns = [
  { field: "EMPID", headerName: "Employee ID", width: 95 },
  {
    field: "EMPName",
    headerName: "Employee Name",
    width: 200,
  },
  { field: "JobTitle", headerName: "Job Title Code", width: 180, hide: true },
  { field: "JobTitleName", headerName: "Job Title Name", width: 200 },
  { field: "Department", headerName: "Department Name", width: 150 },
  { field: "MainLocation", headerName: "Main Location Name", width: 150 },
  { field: "CurrentLocation", headerName: "Current Location", width: 130 },
  { field: "Supervisor", headerName: "Supervisor ID", width: 120 },
  { field: "SupervisorName", headerName: "Supervisor Name", width: 200 },
  {
    field: "AchivedPerc",
    headerName: "Average Achieved %",
    width: 150,
  },
  { field: "B_Achieved", headerName: "Total Achieved Points", width: 160 },
  {
    field: "B_AdjustedPoints",
    headerName: "Total Adjusted Points",
    width: 150,
  },
];

export default function HRReviewReport() {
  const vRdxDBLocation = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const [rows, setRows] = useState([]);
  const [attrbutesData, setattrbutesData] = useState({
    deparmentList: [],
    jobTitleList: [],
  });
  const [summary, setSummary] = useState({
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    locations: [vRdxDBLocation[0]?.Uid],
    departments: [],
    jobTitles: [],
  });

  const handleSelectionChange = (newValue, field) => {
    const selectedUids = newValue.map((loc) =>
      field === "locations" ? loc.Uid : loc.UId
    );
    setSummary((prev) => ({ ...prev, [field]: selectedUids }));
  };

  const handleLoad = async () => {
    const obj = {
      P_FromDate: moment(summary?.fromDate).format("MM-DD-YYYY"),
      P_ToDate: moment(summary?.toDate).format("MM-DD-YYYY"),
      P_Location:
        summary?.locations.length > 0 ? (summary?.locations).toString() : "",
      P_Jobtitle:
        summary?.jobTitles.length > 0 ? (summary?.jobTitles).toString() : "",
      P_Department:
        summary?.departments.length > 0
          ? (summary?.departments).toString()
          : "",
    };
    const response = await onGetHRMonthly_Review_Summary(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      console.log("handleDetails", response?.data?.ResultSet);
      setRows(response?.data?.ResultSet);
    } else {
      setRows([]);
    }
  };

  const getAttributes = async () => {
    const response = await onGetHRMonthly_Review_Atrributes();
    if (response?.data?.ResultSet && response?.data?.Type === "Success") {
      // Map over HRDEPARTMENT and HRJOBTITLE arrays to trim the UId values
      const hrDepartment = response?.data?.ResultSet.HRDEPARTMENT.map(
        (item) => ({
          ...item,
          UId: item.UId.trim(),
        })
      );
      const hrJobTitle = response?.data?.ResultSet.HRJOBTITLE.map((item) => ({
        ...item,
        UId: item.UId.trim(),
      }));
      setattrbutesData((prev) => ({
        ...prev,
        deparmentList: hrDepartment,
        jobTitleList: hrJobTitle,
      }));
    }
  };

  useEffect(() => {
    handleLoad();
    getAttributes();
  }, []);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const departments = attrbutesData?.deparmentList || [];
  const jobTitles = attrbutesData?.jobTitleList || [];

  const selectedDepartments = departments?.filter(
    (loc) =>
      Array.isArray(summary.departments) &&
      summary.departments.includes(loc.UId)
  );

  const selectedJobTitles = jobTitles?.filter(
    (loc) =>
      Array.isArray(summary.jobTitles) && summary.jobTitles.includes(loc.UId)
  );

  // Create a new options array with a "Select All" option added at the top.
  const optionsWithSelectAllDept = [
    { UId: "all", Name1: "Select All Department" },
    ...departments,
  ];

  const optionsWithSelectAllJobTitles = [
    { UId: "all", Name1: "Select All Job Title" },
    ...jobTitles,
  ];

  return (
    <>
    <div className="div-container">
      <Grid container spacing={1.5} mt={0.5} mb={2}>
        <Grid item xs={6} md={1.5}>
          <div style={{ width: "100%" }}>
            <CmpDatePicker
              xLabelText={"From Date"}
              xValue={summary.fromDate}
              xOnChange={(newValue) =>
                setSummary((prev) => ({ ...prev, fromDate: newValue.$d }))
              }
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
              xFullWidth={true}
              size="small"
              isFoucesd={true}
            />
          </div>
        </Grid>
        <Grid item xs={6} md={1.5}>
          <div style={{ width: "100%" }}>
            <CmpDatePicker
              xLabelText={"To Date"}
              xValue={summary.toDate}
              xOnChange={(newValue) =>
                setSummary((prev) => ({ ...prev, toDate: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
              xFullWidth={true}
              size="small"
            />
          </div>
        </Grid>
        <Grid item xs={6} md={4.5}>
          <Autocomplete
            multiple
            size="small"
            options={vRdxDBLocation || []}
            getOptionLabel={(option) => option?.Name1 || ""}
            value={
              vRdxDBLocation?.filter((loc) =>
                Array.isArray(summary.locations)
                  ? summary.locations.includes(loc.Uid)
                  : []
              ) || []
            }
            isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
            onChange={(event, newValue) =>
              handleSelectionChange(newValue, "locations")
            }
            disableCloseOnSelect
            PopperComponent={(props) => (
              <Popper
                {...props}
                style={{
                  zIndex: 1300,
                }}
                placement="bottom-start"
              />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location"
                placeholder="Search..."
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <MenuItem
                {...props}
                sx={{
                  height: "31px", // Set the exact height
                  minHeight: "31px", // Ensure the height is consistent
                  padding: "0 8px", // Adjust padding to match the height
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={selected}
                />
                <ListItemText
                  primary={option?.Name1}
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                />
              </MenuItem>
            )}
          />
        </Grid>
        <Grid item xs={6} md={4.5}>
          <Autocomplete
            multiple
            size="small"
            options={optionsWithSelectAllDept}
            getOptionLabel={(option) => option?.Name1 || ""}
            value={selectedDepartments}
            isOptionEqualToValue={(option, value) => option.UId === value.UId}
            onChange={(event, newValue) => {
              const selectAllOption = newValue.find(
                (option) => option.UId === "all"
              );
              if (selectAllOption) {
                if (selectedDepartments.length === departments.length) {
                  handleSelectionChange([], "departments");
                } else {
                  handleSelectionChange(departments, "departments");
                }
              } else {
                handleSelectionChange(newValue, "departments");
              }
            }}
            disableCloseOnSelect
            PopperComponent={(props) => (
              <Popper
                {...props}
                style={{
                  zIndex: 1300,
                }}
                placement="bottom-start"
              />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Department"
                placeholder="Search..."
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => {
              // Render the "Select All" option differently.
              if (option.UId === "all") {
                const isAllSelected =
                  selectedDepartments.length === departments.length;
                return (
                  <MenuItem
                    {...props}
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      size="small"
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={isAllSelected}
                    />
                    <ListItemText
                      primary="Select All Department"
                      primaryTypographyProps={{
                        fontSize: "12px",
                        lineHeight: "1.2",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </MenuItem>
                );
              }

              // Render regular department options.
              return (
                <MenuItem
                  {...props}
                  sx={{
                    height: "31px",
                    minHeight: "31px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    size="small"
                    icon={icon}
                    checkedIcon={checkedIcon}
                    checked={selected}
                  />
                  <ListItemText
                    primary={option?.Name1}
                    primaryTypographyProps={{
                      fontSize: "12px",
                      lineHeight: "1.2",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  />
                </MenuItem>
              );
            }}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Autocomplete
            multiple
            size="small"
            options={optionsWithSelectAllJobTitles}
            getOptionLabel={(option) => option?.Name1 || ""}
            value={selectedJobTitles}
            isOptionEqualToValue={(option, value) => option.UId === value.UId}
            onChange={(event, newValue) => {
              const selectAllOption = newValue.find(
                (option) => option.UId === "all"
              );
              if (selectAllOption) {
                if (selectedJobTitles.length === jobTitles.length) {
                  handleSelectionChange([], "jobTitles");
                } else {
                  handleSelectionChange(jobTitles, "jobTitles");
                }
              } else {
                handleSelectionChange(newValue, "jobTitles");
              }
            }}
            disableCloseOnSelect
            PopperComponent={(props) => (
              <Popper
                {...props}
                style={{
                  zIndex: 1300,
                }}
                placement="bottom-start"
              />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Job Title"
                placeholder="Search..."
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => {
              // Render the "Select All" option differently.
              if (option.UId === "all") {
                const isAllSelected =
                  selectedJobTitles.length === jobTitles.length;
                return (
                  <MenuItem
                    {...props}
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      size="small"
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={isAllSelected}
                    />
                    <ListItemText
                      primary="Select All Job Title"
                      primaryTypographyProps={{
                        fontSize: "12px",
                        lineHeight: "1.2",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </MenuItem>
                );
              }
              // Render regular department options.
              return (
                <MenuItem
                  {...props}
                  sx={{
                    height: "31px",
                    minHeight: "31px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    size="small"
                    icon={icon}
                    checkedIcon={checkedIcon}
                    checked={selected}
                  />
                  <ListItemText
                    primary={option?.Name1}
                    primaryTypographyProps={{
                      fontSize: "12px",
                      lineHeight: "1.2",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  />
                </MenuItem>
              );
            }}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Stack direction={"row"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mr: 1 }}
              onClick={handleLoad}
            >
              Load
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: {
            xs: "62.5vh",
            sm: "61.5vh",
            md: "67vh",
            lg: "70vh",
            xl: "75vh",
          },
          width: "100%",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          rows={rows}
          getRowId={(row) => row.EMPID}
          columns={gridColumns}
          components={{
            Toolbar: GridToolbar,
          }}
          hideFooter={rows.length < 100}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
              '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
          }}
        />
      </Box>
      </div>
    </>
  );
}
